import { useQuery } from '@tanstack/react-query';
import { useAnomalyQueryOptions } from './useAnomalyQueryOptions';

export const useAnomaly = (projectId: number, anomalyId: number, enabled = true) => {
  const anomalyQueryOptions = useAnomalyQueryOptions();

  return useQuery({
    ...anomalyQueryOptions(projectId, anomalyId),
    enabled,
  },
  );
};
